module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/binocular-a8c07479fb58573b08deaebb63879da1.svg";